import React from "react";
// import your 5 images
import backgroundImage from "../../assets/apocalyptic_bg1.png";
import backgroundImage1 from "../../assets/apocalyptic_bg2.png";
import backgroundImage2 from "../../assets/apocalyptic_bg3.png";
import backgroundImage3 from "../../assets/apocalyptic_bg4.png";
import backgroundImage4 from "../../assets/apocalyptic_bg5.png";
import backgroundImage5 from "../../assets/apocalyptic_bg6.png";

export default function SixImageSections() {
  const images = [
    backgroundImage,
    backgroundImage1,
    backgroundImage2,
    backgroundImage3,
    backgroundImage4,
    backgroundImage5,
  ];

  return (
    <>
      {/* Images Section */}
      <div className="flex flex-col gap-0 pt-16 pb-16">
        {images.map((image, index) => (
          <div key={index} className="relative w-full">
            {/* 🔹 Blurred Background */}
            <div
              className="absolute inset-0 bg-cover bg-center blur-2xl"
              style={{ backgroundImage: `url(${backgroundImage})` }}
            ></div>

            {/* 🔹 Centered Sharp Container */}
            <div className="relative z-10 flex justify-center items-center py-0 px-4">
              <img
                src={image}
                alt={`Section ${index + 1}`}
                className="max-w-full h-auto"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Logo Section */}
      <section
        style={{
          width: "100%",
          minHeight: "25svh",
          scrollSnapAlign: "start",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          paddingBottom: "40px",
        }}
      >
        <img
          src="/logo.png"
          alt="Logo"
          style={{
            width: "80px",
            height: "auto",
            opacity: 0.9,
          }}
        />
      </section>
    </>
  );
}